import { render, staticRenderFns } from "./preview_modal.vue?vue&type=template&id=9920556e&scoped=true"
import script from "./preview_modal.vue?vue&type=script&lang=js"
export * from "./preview_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9920556e",
  null
  
)

export default component.exports